import { supabase } from "@/shared/lib/supabase";
import type { FlowAnswers } from "@/shared/constants/flowTypes";

const STORAGE_KEY = "google_oauth_context";

type OAuthContextType =
  | "onboarding"
  | "login"
  | "invite-new"
  | "invite-existing"
  | "lawyer-signup"
  | "lawyer-login";

interface GoogleOAuthContext {
  type: OAuthContextType;
  redirectPath: string;
  answers?: FlowAnswers;
  token?: string;
}

export function getGoogleOAuthContext(): GoogleOAuthContext | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as GoogleOAuthContext;
  } catch {
    return null;
  }
}

export function clearGoogleOAuthContext(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export async function startGoogleOAuth(context: GoogleOAuthContext): Promise<string | null> {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(context));

  const redirectTo = `${window.location.origin}${context.redirectPath}`;

  const { error } = await supabase.auth.signInWithOAuth({
    provider: "google",
    options: { redirectTo },
  });

  if (error) {
    clearGoogleOAuthContext();
    return error.message;
  }

  return null;
}
